import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <header className="privacy-header">
          <Link to="/" className="back-link">← Back to World Rosary</Link>
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
        </header>

        <div className="privacy-body">
          <section className="privacy-section">
            <h2>Our Commitment to Privacy</h2>
            <p>
              World Rosary is committed to protecting your privacy. This site does not collect any personal information from its users. We believe in creating a safe, anonymous space for prayer and spiritual connection.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Information We Do NOT Collect</h2>
            <ul>
              <li><strong>No logins or passwords</strong> - You can use our service without creating an account</li>
              <li><strong>No cookies</strong> - We do not use tracking cookies or store data on your device</li>
              <li><strong>No advertisements</strong> - Our service is completely ad-free</li>
              <li><strong>No names</strong> - We don't ask for or store personal names</li>
              <li><strong>No IP addresses</strong> - We don't track or store your IP address</li>
              <li><strong>No email addresses</strong> - We don't collect or store email addresses</li>
              <li><strong>No phone numbers</strong> - We don't collect or store phone numbers</li>
              <li><strong>No location data</strong> - We don't track your physical location</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>What We Do Track</h2>
            <p>
              The only data we collect is anonymous, aggregated information to help us understand how many people are using our service at any given time. This includes:
            </p>
            <ul>
              <li>Anonymous count of active users (displayed as "Praying Now")</li>
              <li>General usage statistics to improve our service</li>
            </ul>
            <p>
              This information cannot be used to identify individual users and is used solely to provide the live count feature and improve our service.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Third-Party Services</h2>
            <p>
              We use minimal third-party services to provide our functionality:
            </p>
            <ul>
              <li><strong>Socket.IO</strong> - For real-time connection to show live user count (anonymous only)</li>
              <li><strong>Donorbox</strong> - For optional donations (handled entirely by Donorbox, not stored by us)</li>
            </ul>
            <p>
              These services have their own privacy policies, and we encourage you to review them if you choose to interact with them.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Data Security</h2>
            <p>
              Since we don't collect personal information, there's no personal data to secure. Our service is designed to be completely anonymous and private by default.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Children's Privacy</h2>
            <p>
              Our service is safe for users of all ages. Since we don't collect any personal information, we don't have any special concerns about children's privacy. Parents can feel confident that their children can use our service safely.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Changes to This Policy</h2>
            <p>
              We may update this privacy policy from time to time. Any changes will be posted on this page with an updated "Last updated" date. We encourage you to review this policy periodically.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Contact Information</h2>
            <p>
              If you have any questions about this privacy policy, please contact us at:
            </p>
            <p>
              <strong>GetVocal, Inc.</strong><br />
              Email: privacy@getvocal.com<br />
              Website: <a href="https://getvocal.com" target="_blank" rel="noopener noreferrer">getvocal.com</a>
            </p>
          </section>

          <section className="privacy-section">
            <h2>Our Mission</h2>
            <p>
              World Rosary is a free service provided by <strong>GetVocal, Inc.</strong> with the goal of creating world peace through prayer of the rosary. We believe that privacy and anonymity are essential for creating a safe space for spiritual connection and prayer.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
